import { createFileRoute, redirect } from '@tanstack/react-router'

// The Progress Notes list replaces this report. It checks no role here: the list
// has no role gate of its own, and the notes it shows are scoped by the API.
export const Route = createFileRoute(
  '/_authenticated/_organization/reports/support-notes'
)({
  beforeLoad: () => {
    throw redirect({ to: '/scheduler/progress-notes', replace: true })
  },
})
